import { useState, useRef, useEffect } from "react";

// Journal photos
import photo1 from "../../assets/journaling/myjournals/IMG_5500.jpg";
import photo2 from "../../assets/journaling/myjournals/IMG_5501.jpg";
import photo3 from "../../assets/journaling/myjournals/IMG_5504.jpg";
import photo4 from "../../assets/journaling/myjournals/IMG_5507.jpg";
import photo5 from "../../assets/journaling/myjournals/IMG_5509.jpg";
import photo6 from "../../assets/journaling/myjournals/IMG_5511.jpg";
import photo7 from "../../assets/journaling/myjournals/IMG_5512.jpg";
import photo8 from "../../assets/journaling/myjournals/IMG_5513.jpg";
import photo9 from "../../assets/journaling/myjournals/IMG_5514.jpg";
import photo10 from "../../assets/journaling/myjournals/IMG_5515.jpg";
import photo11 from "../../assets/journaling/myjournals/IMG_5516.jpg";
import photo12 from "../../assets/journaling/myjournals/IMG_5517.jpg";

const journalPhotos = [
  photo1, photo2, photo3, photo4, photo5, photo6,
  photo7, photo8, photo9, photo10, photo11, photo12,
];

function JournalGalleryCard() {
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);
  const touchStartX = useRef(null);

  const openViewer = (i = 0) => {
    setIndex(i);
    setIsOpen(true);
  };
  const closeViewer = () => setIsOpen(false);
  const next = () => setIndex((i) => (i + 1) % journalPhotos.length);
  const prev = () => setIndex((i) => (i - 1 + journalPhotos.length) % journalPhotos.length);

  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (delta > 50) prev();
    else if (delta < -50) next();
    touchStartX.current = null;
  };

  // Keyboard support (Esc, arrows) while the viewer is open
  useEffect(() => {
    if (!isOpen) return;
    const handleKey = (e) => {
      if (e.key === "Escape") closeViewer();
      if (e.key === "ArrowRight") next();
      if (e.key === "ArrowLeft") prev();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [isOpen]);

  return (
    <>
      <div
        className="journal-type-card journal-stack-card"
        onClick={() => openViewer(0)}
        data-aos="fade-up"
        data-aos-delay="400"
      >
        <div className="journal-stack">
          {journalPhotos.slice(0, 3).map((src, i) => (
            <img
              key={i}
              src={src}
              alt={`Journal page ${i + 1}`}
              className="journal-stack-img"
              style={{ "--i": i }}
            />
          ))}
        </div>
        <h3>My Journals</h3>
        <p>Real pages from my own notebooks.</p>
      </div>

      {isOpen && (
        <div className="journal-viewer-overlay" onClick={closeViewer}>
          <button className="journal-viewer-close" onClick={closeViewer}>✕</button>

          <button
            className="journal-viewer-nav prev"
            onClick={(e) => { e.stopPropagation(); prev(); }}
          >
            ‹
          </button>

          <img
            src={journalPhotos[index]}
            alt={`Journal page ${index + 1}`}
            className="journal-viewer-img"
            onClick={(e) => e.stopPropagation()}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          />

          <button
            className="journal-viewer-nav next"
            onClick={(e) => { e.stopPropagation(); next(); }}
          >
            ›
          </button>

          <div className="journal-viewer-counter">
            {index + 1} / {journalPhotos.length}
          </div>
        </div>
      )}
    </>
  );
}

export default JournalGalleryCard;